<template>
  <div class="loading-comp">
    <div class="line"></div>
    <div class="line"></div>
    <div class="line"></div>
    <div class="line"></div>
    <div class="line"></div>
  </div>
</template>

<script>
export default {
  name: 'SytScreenLoding'
}
</script>

<style lang="less" scoped>
.loading-comp {
  box-sizing: border-box;
  display: flex;
  align-items: flex-end;
  height: 50px;
}
.line {
  width: 6px;
  height: 8px;
  margin-right: 4px;
  border-radius: 15px;
  background-color: #34dee5;
}
.line:nth-child(1) {
  animation: loading 1.5s 0s infinite;
}
.line:nth-child(2) {
  animation: loading 1.5s 0.3s infinite;
}
.line:nth-child(3) {
  animation: loading 1.5s 0.6s infinite;
}
.line:nth-child(4) {
  animation: loading 1.5s 0.9s infinite;
}
.line:nth-child(5) {
  animation: loading 1.5s 1.2s infinite;
}
@keyframes loading {
  50% {
    height: 25px;
  }
  100% {
    height: 8px;
  }
}
</style>